import VueRouter from 'vue-router';
import MainPage from "@/components/MainPage.vue";
import Room from "@/components/Room.vue";

const routes = [
        { path: '/room/:roomId', component: Room },
        { name: 'joinedRoom', path: '/room/:roomId/:playerId', component: Room },
        { path: '/', component: MainPage }
]

export default new VueRouter({
        mode: 'hash',
        routes
});